export default __webpack_public_path__ + "locales/lo-LA/PaymentsEnterprise.json?hash=d4e74e9f5ec02d7a79edb3d02491a575";